import { z } from "zod"

import { LectureActionEnum } from "@/common/enum/lectureActionEnum"
import { SemesterEnum } from "@/common/enum/semesterEnum"
import { LectureSchema } from "@/common/schemas/lecture"

// GET /api/users/:userId/wishlist
export const GETRequest = z.object({
    year: z.number().int(),
    semester: z.enum(SemesterEnum),
})

export const GETResponse = z.object({
    courses: z.array(
        z.object({
            id: z.number().int(),
            name: z.string(),
            code: z.string(),
            type: z.string(),
            completed: z.boolean(),
            lectures: z.array(LectureSchema),
        }),
    ),
})

export type GETWishlistResponse = z.infer<typeof GETResponse>

// PATCH /api/users/:userId/wishlist
export const PATCHRequest = z.object({
    lectureId: z.number().int(),
    mode: z.enum(LectureActionEnum),
})

export const PATCHResponse = z.object({})

export type PATCHWishlistBody = z.infer<typeof PATCHRequest>
